import { ChangeImageModal } from './ChangeImageModal';

export default ChangeImageModal;
